<template>
    <div class="panel panel-default">
        <div class="panel-heading" style="display: flex; justify-content: space-between; align-items: center">
            <h5 style="flex-grow: 5; flex-basis: 0">
                My Meetings
            </h5>

            <select-widget
                v-model="horizon"
                class="form-control input-sm"
                :nullable="true"
                placeholder="(today)"
                :options="horizonOptions"
                style="flex-grow: 1; flex-basis: 0"
            />
        </div>

        <loading-spinner v-if="loading"></loading-spinner>

        <ul v-else class="list-group">
            <li v-for="meeting in meetings.data" class="list-group-item" style="padding: 10px 0">
                <div style="display: flex; flex-direction: row">
                    <div class="text-muted"
                         style="flex-grow: 1; flex-basis: 0; font-size: 24px; display: flex; justify-content: center; align-items: center;">
                        <i class="fa fa-handshake"></i>
                    </div>

                    <div style="flex-grow: 6; flex-basis: 0">
                        <router-link :to="'/companies/' + meeting.attributes.company_id">
                            {{ meeting.attributes.company_name }}
                        </router-link>

                        <br>

                        {{ meeting.attributes.category | verboseCategory }} &middot;
                        {{ meeting.attributes.is_new_business ? 'New Business' : 'More Business' }}

                        <br>

                        {{ meeting.attributes.starts_at | datetime }} - {{ meeting.attributes.ends_at | time }}
                    </div>

                    <div
                        style="flex-grow: 2; flex-basis: 0; font-size: 24px; display: flex; justify-content: flex-end; align-items: center;">
                        <div class="btn-group" style="margin-right: 15px">
                            <div class="dropdown" style="display: inline">
                                <button
                                    class="btn btn-white dropdown-toggle"
                                    type="button"
                                    data-toggle="dropdown"
                                >
                                    <i class="fa fa-check"/>
                                </button>

                                <ul class="dropdown-menu">
                                    <li>
                                        <router-link
                                            :to="'/companies/' + meeting.attributes.company_id + '/opportunities/create?meeting_id=' + meeting.id"
                                        >
                                            Create opportunity
                                        </router-link>

                                        <a href="#" @click.prevent="hold(meeting)">
                                            Mark as held
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </li>

            <li v-if="meetings.meta.total > 5" class="list-group-item" style="padding: 10px 0">
                <resource-pager :pagination="meetings.meta" @navigate="navigate($event)"/>
            </li>

            <li v-if="meetings.data.length === 0" class="list-group-item text-center" style="padding: 50px;">
                <i class="fa fa-glass-cheers" style="font-size: 96px;"></i>

                <br><br>

                You have no meetings to hold!
            </li>
        </ul>
    </div>
</template>

<script>
import http from '@/http'
import modal from '@/modal'
import moment from 'moment'
import notify from '@/notify'
import store from '@/store'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import Pager from '@/components/Lists/Pager'
import ResourcePager from '@/components/Utilities/Pagination/ResourcePager'
import SelectWidget from '@/vendor/forms/FormGroups/Widgets/Select'

export default {
    components: {LoadingSpinner, Pager, ResourcePager, SelectWidget},

    data() {
        return {
            meetings: null,

            loading: true,

            editing: null,

            horizon: null,
            shared: store,
            page: 1
        }
    },

    mounted() {
        this.load()
    },

    watch: {
        horizon() {
            this.load()
        }
    },

    computed: {
        horizonOptions() {
            return [
                {value: 1, label: '+1 days'},
                {value: 2, label: '+2 days'},
                {value: 3, label: '+3 days'},
                {value: 7, label: '+7 days'},
                {value: 14, label: '+14 days'},
                {value: 30, label: '+30 days'},
                {value: 'all', label: 'All'}
            ]
        },

        startsTo() {
            if (this.horizon === 'all') {
                return null
            }

            return moment().add(this.horizon, 'days').endOf('day').format('YYYY-MM-DD HH:mm:ss')
        }
    },

    methods: {
        load() {
            http.get('/api/v2/meetings', {
                page_size: 5,
                page: this.page,
                'filter[user_id]': this.shared.user.id,
                'filter[starts_to]': this.startsTo,
                'filter[status]': 'booked',
                sort: 'starts_at'
            })
                .then(response => {
                    this.meetings = response.data

                    this.loading = false
                })
        },

        hold(meeting) {
            modal.confirm('Are you sure that you want to mark the meeting as held?', () => {
                http.post('/api/v2/held-meetings', {meeting_id: meeting.id})
                    .then(() => {
                        notify.success('The meeting was marked as held')

                        this.navigate(1)
                    })
                    .catch(error => {
                        if (error.response.status === 400) {
                            return notify.error(error.response.data.message)
                        }

                        throw error
                    })
            })
        },

        navigate(page) {
            this.page = page

            this.load()
        }
    },

    filters: {
        verboseCategory(value) {
            if (value === 'online') {
                return 'Online'
            }

            if (value === 'physical') {
                return 'Physical'
            }
        }
    }
}
</script>
